import { Button, Space } from 'antd';
import React from 'react';
import { User } from 'store/auth/models';
import { AvatarSizes, renderAvatar } from './render-avatar';
import { BoldNameSpan, GraySpan } from 'components/Custom/spans';
import { AccountType } from 'store/api/enums';
import { DeleteOutlined } from '@ant-design/icons';
import { StyledPopconfirm } from 'components/Custom/Popconfirm';
import { useTranslation } from 'react-i18next';
import { getAccountTypeLabel } from 'i18n/accountTypeLabel';

interface RenderUserDetailProps {
  record: User;
  showOption?: boolean;
  showRole?: boolean;
  hideEmail?: boolean;
  showDelete?: boolean;
  noPadding?: boolean;
  memberRemove?: (accountId: string) => void;
}

export const RenderUserDetail: React.FC<RenderUserDetailProps> = ({
  record,
  showOption = false,
  showRole = false,
  hideEmail = false,
  showDelete = false,
  noPadding = false,
  memberRemove,
}) => {
  const { t } = useTranslation();
  const onMemberRemove = () => memberRemove && memberRemove(record.accountUuid);
  return (
    <Space
      style={{
        borderBottom: !showOption ? '1px solid var(--color-border, #dbeae3)' : 'none',
        padding: noPadding ? '0px' : !showOption ? '14px 0px' : '8px 0px',
      }}
    >
      {renderAvatar(
        record?.firstName,
        record?.lastName,
        AvatarSizes.DEFAULT,
        record?.userUuid,
        record?.profilePicture
      )}
      <Space
        direction="vertical"
        style={{ rowGap: '0', minWidth: !showOption ? 210 : 170 }}
      >
        <BoldNameSpan
          style={{ fontSize: !showOption ? 15 : 13, fontWeight: 600 }}
        >{`${record?.firstName} ${record?.lastName}`}</BoldNameSpan>

        {!hideEmail && (
          <BoldNameSpan //@ts-ignore
            fontWeight={400}
            style={{ color: 'var(--color-text-muted, #5a6a6a)' }}
          >
            {record?.email}
          </BoldNameSpan>
        )}
      </Space>
      {showRole && (
        <GraySpan style={{ marginLeft: '0' }}>
          {getAccountTypeLabel(record?.accountType, t)}
        </GraySpan>
      )}

      {showDelete && AccountType[record.accountType] !== AccountType.OWNER && (
        <StyledPopconfirm // @ts-ignore
          title={t('users.remove-user-title-from-entity')}
          description={<span>{t('users.delete-user-description-from-entity')}</span>}
          onConfirm={onMemberRemove}
          placement="left"
          okText={t('common.yes')}
          cancelText={t('common.cancel')}
        >
          <Button
            type="link"
            shape="circle"
            icon={<DeleteOutlined />}
            aria-label={t('common.delete')}
          />
        </StyledPopconfirm>
      )}
    </Space>
  );
};
